
import { PropTypes } from 'prop-types';
const EducatorCard = ({ name, designation, college, img }) => {
    return (
        <div className="w-[229.67px] 2xl:w-96 2xl:h-[30rem] relative shrink-0 snap-center group select-none h-[335.54px] bg-slate-500/30 rounded-[28px] overflow-hidden bg-cover bg-no-repeat bg-center 2xl:bg-top 2xl:rounded-[45px]" style={{ backgroundImage: `url('${img}')` }}>
            <div className='absolute w-full h-full flex items-center justify-center top-0 bg-gradient-to-b from-black/20 to-black/40 z-20 opacity-0 group-hover:opacity-100 transition-all duration-500'>
                <div className="flex flex-col items-center h-full justify-center gap-3 p-4 ">
                    <h1 className="text-white font-bold  text-center text-xl 2xl:text-3xl ">{name}</h1>
                    <p className="text-white text-[9px]  text-center flex flex-col  items-center 2xl:text-sm"><span className='text-sm 2xl:text-lg font-semibold'>{designation}</span><span>{college}</span></p>
                </div>
            </div>


        </div>
    )
}
EducatorCard.propTypes = {
    name: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    college: PropTypes.string,
    img: PropTypes.string.isRequired
}
export default EducatorCard